import { useState } from "react";
import { API } from "../../../services/api";

const CONFIG = { noRedirectOn401: true };
const EMPTY_REVISION = { revisionDate: "", notes: "", procedure: null };
const EMPTY_RENTAL_PERIOD = { startDate: "", endDate: "" };

// Révisions et périodes de location passées du matériel sélectionné. Après une suppression, le parc est relu.
export function useParkHistory(park) {
    const { endpoint, selectedItem, replaceItem, setItems, setSaving, setError, refresh } = park;
    const [revisionForm, setRevisionForm] = useState(EMPTY_REVISION);
    const [rentalHistoryForm, setRentalHistoryForm] = useState(EMPTY_RENTAL_PERIOD);

    const saveForSelected = async (request, onSaved, failure) => {
        if (!selectedItem) return;
        setSaving(true);
        setError(null);
        try {
            const response = await request(`${endpoint}/${selectedItem.id}`);
            replaceItem(selectedItem.id, response.data);
            onSaved();
        } catch (err) {
            setError(err.response?.data?.message || failure);
        } finally {
            setSaving(false);
        }
    };

    const deleteForSelected = async (question, path, removeFromItem, failure) => {
        if (!selectedItem || !globalThis.confirm(question)) return;
        setError(null);
        try {
            await API.delete(`${endpoint}/${selectedItem.id}/${path}`, CONFIG);
            setItems(prev => prev.map(item => item.id === selectedItem.id ? removeFromItem(item) : item));
            refresh();
        } catch (err) {
            setError(err.response?.data?.message || failure);
        }
    };

    const addRevision = event => {
        event.preventDefault();
        const data = new FormData();
        data.append("revisionDate", revisionForm.revisionDate);
        data.append("notes", revisionForm.notes || "");
        if (revisionForm.procedure) data.append("procedure", revisionForm.procedure);
        return saveForSelected(
            base => API.post(`${base}/revisions`, data, CONFIG),
            () => setRevisionForm(EMPTY_REVISION),
            "Impossible d'ajouter la révision.",
        );
    };

    const addRentalPeriod = event => {
        event.preventDefault();
        return saveForSelected(
            base => API.post(`${base}/rental-history`, rentalHistoryForm, CONFIG),
            () => setRentalHistoryForm(EMPTY_RENTAL_PERIOD),
            "Impossible d'ajouter cette période de location.",
        );
    };

    const deleteRevision = revision => deleteForSelected(
        "Supprimer cette révision ?",
        `revisions/${revision.id}`,
        item => ({ ...item, revisions: item.revisions.filter(current => current.id !== revision.id) }),
        "Impossible de supprimer cette révision.",
    );

    const deleteRentalPeriod = period => deleteForSelected(
        "Supprimer cette période de location ?",
        `rental-history/${period.id}`,
        item => ({ ...item, rentalHistory: (item.rentalHistory || []).filter(current => current.id !== period.id) }),
        "Impossible de supprimer cette période.",
    );

    return {
        revisionForm, setRevisionForm, rentalHistoryForm, setRentalHistoryForm,
        addRevision, addRentalPeriod, deleteRevision, deleteRentalPeriod,
    };
}
